$(document).ready(function(){
    $('.faq-menu .menu-item:first-child').addClass('active');
    $('.faq-menu .menu-item').click(function() {
        $(this).addClass('active');
        $(this).siblings().removeClass('active');
    })

    $('.faq-main-section .qa-item .question').click(function() {
      $(this).next('.answer').slideToggle();
      $(this).toggleClass('active');
    })
})

	
